import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalAiDownloadManagerService, type LocalAiDownloadTask } from '../../services/local-ai-download-manager.service';

@Component({
  selector: 'app-local-ai-download-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './local-ai-download-overlay.component.html',
  styleUrl: './local-ai-download-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalAiDownloadOverlayComponent {
  readonly downloads = inject(LocalAiDownloadManagerService);

  progressLabel(task: LocalAiDownloadTask): string {
    if (task.status === 'queued') return 'Queued';
    if (task.status === 'completed') return 'Downloaded';
    if (task.status === 'cancelled') return 'Cancelled';
    if (task.status === 'failed') return task.error || 'Download failed';
    const size = task.totalBytes > 0
      ? `${this.downloads.formatBytes(task.downloadedBytes)} of ${this.downloads.formatBytes(task.totalBytes)}`
      : this.downloads.formatBytes(task.downloadedBytes);
    return `${task.percent}% · ${size}`;
  }

  canCancel(task: LocalAiDownloadTask): boolean {
    return task.status === 'queued' || task.status === 'downloading';
  }
}
